import React, {useState, useEffect, useContext} from 'react';
import styles from "./NotificationWrapper.module.css"
import {NotificationContext} from "../../Context/NotificationContext"
import { NotificationItem } from './NotificationItem/NotiifcationItem';
import { InputSwitch } from "primereact/inputswitch";

export const NotificationWrapper = () => {

    const [newOnlyToggle, setNewOnlyToggle] = useState(false);
    const { notifications, unreadList, unreadCount, loadNotifications } = useContext(NotificationContext);

    useEffect(() => {
        loadNotifications();
    }, [])

    if(!notifications.length){
        return (
            <div>
                <h3 style={{height:"95vh", display:"flex", justifyContent:"center", flexDirection:'column', alignItems:'center'}}>На жаль, у Вас ще немає сповіщень.</h3>
            </div>
        )
    }

    return (
        <div className={styles.pageWrapper}>


            <div className={styles.messagesContainer}>
                <div className={`${styles.onlyNewContainer}`}>
                    <h6>Нових {unreadCount} шт </h6>
                    {unreadCount > 0 ? 
                        <div className="flex justify-content-center" style={{gap: '5px'}}>
                            <span>Тільки непрочитані</span>
                            <InputSwitch checked={newOnlyToggle} onChange={(e) => setNewOnlyToggle(e.value)} />
                        </div>
                    : null}
                </div>
            {newOnlyToggle ? 
                unreadList.map(message => (
                    <NotificationItem
                    id={message.Id}
                    key={message.Id}
                    subject={message.Subject}
                    messageTextValue={message.MessageTextValue}
                    createOn={message.CreateOn}
                    isRead={message.IsRead}
                    />
                )) : 
                
                notifications.map(message => (
                    <NotificationItem
                    id={message.Id}
                    key={message.Id}
                    subject={message.Subject}
                    messageTextValue={message.MessageTextValue}
                    createOn={message.CreateOn}
                    isRead={message.IsRead}
                    />
                ))
                }
            </div>
        </div>
    )
} 